var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
import { determineRootNodeId } from '../utils/dialogueUtils';
/**
 * Get all dialogues for a level
 */
export const getLevelDialogues = (levelId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const dialogues = yield client.get(`/levels/${levelId}/dialogues`);
        return dialogues;
    }
    catch (error) {
        console.error('Error fetching level dialogues:', error);
        // Return empty array if API fails
        return [];
    }
});
/**
 * Get dialogue by ID
 */
export const getDialogueById = (levelId, dialogueId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const dialogue = yield client.get(`/levels/${levelId}/dialogues/${dialogueId}`);
        return dialogue;
    }
    catch (error) {
        console.error(`Error fetching dialogue with ID ${dialogueId}:`, error);
        // Rethrow error to be handled by caller
        throw error;
    }
});
/**
 * Create new dialogue
 */
export const createDialogue = (levelId, dialogue) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // Always validate and set the correct rootNodeId before sending to the server
        const dialogueToCreate = Object.assign(Object.assign({}, dialogue), { rootNodeId: determineRootNodeId(dialogue) });
        const createdDialogue = yield client.post(`/levels/${levelId}/dialogues`, dialogueToCreate);
        return createdDialogue;
    }
    catch (error) {
        console.error('Error creating dialogue:', error);
        throw error;
    }
});
/**
 * Update existing dialogue
 */
export const updateDialogue = (levelId, dialogueId, dialogue) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // Always validate and set the correct rootNodeId before sending to the server
        const dialogueToUpdate = Object.assign(Object.assign({}, dialogue), { rootNodeId: determineRootNodeId(dialogue) });
        const updatedDialogue = yield client.put(`/levels/${levelId}/dialogues/${dialogueId}`, dialogueToUpdate);
        return updatedDialogue;
    }
    catch (error) {
        console.error(`Error updating dialogue with ID ${dialogueId}:`, error);
        throw error;
    }
});
/**
 * Delete dialogue
 */
export const deleteDialogue = (levelId, dialogueId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.delete(`/levels/${levelId}/dialogues/${dialogueId}`);
    }
    catch (error) {
        console.error(`Error deleting dialogue with ID ${dialogueId}:`, error);
        throw error;
    }
});
/**
 * Restore an archived dialogue
 */
export const restoreDialogue = (levelId, dialogueId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.patch(`/levels/${levelId}/dialogues/${dialogueId}/restore`);
    }
    catch (error) {
        console.error(`Error restoring dialogue with ID ${dialogueId}:`, error);
        throw error;
    }
});
/**
 * Permanently delete a dialogue
 */
export const deleteDialoguePermanent = (levelId, dialogueId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield client.delete(`/levels/${levelId}/dialogues/${dialogueId}/permanent`);
    }
    catch (error) {
        console.error(`Error permanently deleting dialogue with ID ${dialogueId}:`, error);
        throw error;
    }
});
